import axiosInstance from '../../../axiosConfig';
import {
  PccTransferPreview,
  PccTransferResult,
  TournamentClub,
  TournamentFormData,
  TournamentOverviewRow,
  TournamentSavePayload,
} from './TournamentAdmin.types';

/** The axios guard rejects a repeated call with this string; the first call is still on its way. */
export const isDuplicateRequest = (error: unknown) =>
  error === 'Duplicate request detected';

export class TournamentAdminService {
  static async fetchOverview(): Promise<TournamentOverviewRow[]> {
    const response = await axiosInstance.get('association/tournament/list');
    return Array.isArray(response.data) ? response.data : [];
  }

  static async fetchClubs(): Promise<TournamentClub[]> {
    const response = await axiosInstance.get('association/tournament/clubs');
    return Array.isArray(response.data) ? response.data : [];
  }

  static async fetchTournament(id: number): Promise<TournamentFormData> {
    const response = await axiosInstance.get(`association/tournament/${id}`);
    return response.data;
  }

  static async fetchPccPreview(id: number): Promise<PccTransferPreview> {
    const response = await axiosInstance.get(
      `association/tournament/${id}/pcc-events`,
    );
    return response.data;
  }

  static async sendToPcc(
    id: number,
    eventNumber: string,
  ): Promise<PccTransferResult> {
    const response = await axiosInstance.post(
      `association/tournament/${id}/send-to-pcc`,
      { eventNumber },
    );
    return response.data;
  }

  static async delete(id: number): Promise<void> {
    await axiosInstance.delete(`association/tournament/${id}`);
  }

  static async save(
    payload: TournamentSavePayload,
  ): Promise<{ status: string; id: number }> {
    const response = await axiosInstance.post(
      'association/tournament/save',
      payload,
    );
    return response.data;
  }
}
